module.exports = __webpack_public_path__ + "static/media/x-fisk.d888937c.svg";